/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { Form, Input, Radio, Select, Button, Divider, Spin, Tooltip } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import { useForm } from 'antd/es/form/Form';
import { countryPhoneCode } from '../../Utils/country-phone-codes';
import UploadComponent from '../Global/CustomAvatar/UploadComponent';
import getCountryFromIP from '../../Utils/GettingCountryFromIP';
import { CheckRiderEnabled } from '../../Utils/CheckFeatures';
import { style } from '../../Styles';

const optionsGender = [
	{ label: 'Male', value: 'Male' },
	{ label: 'Female', value: 'Female' },
	{ label: 'Undisclosed', value: 'Undisclosed' },
];
const validateMessages = {
	types: {
		email: '${label} is not a valid email',
	},
};

const RiderForm = ({
	onSave,
	onSaveFailed,
	rider,
	onCancel,
	onDirty,
	unsavedChanges,
	fileList,
	setFileList,
	handleUpload,
	uploading,
	setIsFileChosen,
	corporates,
	corporatesLoading,
	initialValues,
	fixedEmail = false,
	fixedCorporate = false,
	hideProfilePicture = false,
	disableSubmitUntilDirty = true,
	submitButtonText,
	submitLoading = false,
	compactActions = false,
}) => {
	const [form] = useForm();
	const [countryFromIp, setCountryFromIp] = useState('Malta');
	const [phoneCodeFromIp, setPhoneCodeFromIp] = useState('356');
	useEffect(() => {
		getCountryFromIP().then((country) => {
			setCountryFromIp(country);
			// Find the corresponding phone code for the country
			const foundCountry = countryPhoneCode.find((c) => c.en === country);
			if (foundCountry) {
				form.setFieldsValue({
					phoneCountryCode: rider ? rider?.phoneCountryCode : foundCountry.phoneCode,
					country: rider ? rider?.country : foundCountry.en,
				});
				setPhoneCodeFromIp(foundCountry.phoneCode);
				setCountryFromIp(foundCountry.en);
			}
		});
	}, []);
	const [selectedGender, setSelectedGender] = useState('');
	const onChangeGender = ({ target: { value } }) => {
		setSelectedGender(value);
	};

	// Corporate handling logic (similar to RiderApprovalSetting)
	const userCorporates = corporates?.corporatesList || [];
	const hasMultipleCorporates = userCorporates.length > 1;

	// Auto-fill corporate when only one exists or when editing existing rider
	useEffect(() => {
		// If editing an existing rider with corporateId, set it
		if (rider?.corporateId) {
			form.setFieldsValue({ corporateId: rider.corporateId });
		}
		// If creating new rider and only one corporate exists, auto-fill it
		else if (!rider && userCorporates.length === 1) {
			form.setFieldsValue({ corporateId: userCorporates[0].id });
		}
	}, [rider, userCorporates, form]);

	useEffect(() => {
		if (initialValues) {
			form.setFieldsValue(initialValues);
		}
	}, [initialValues, form]);

	return (
		<Form
			form={form}
			name='rider'
			layout='vertical'
			autoComplete='off'
			initialValues={{ ...rider, ...initialValues }}
			validateMessages={validateMessages}
			onFinish={onSave}
			onFinishFailed={onSaveFailed}
			onValuesChange={() => onDirty()}>
			{!hideProfilePicture && (
				<Form.Item
					label='Profile Picture'
					name='profilePicture'
					style={{ textAlign: 'center' }}>
					<Spin spinning={uploading}>
						<UploadComponent
							fileList={fileList}
							setFileList={setFileList}
							handleUpload={handleUpload}
							uploading={uploading}
							setIsFileChosen={setIsFileChosen}
						/>
					</Spin>
				</Form.Item>
			)}
			<Form.Item
				label='Name'
				name='name'
				rules={[{ required: true, message: 'Please input rider name' }]}>
				<Input />
			</Form.Item>
			<Form.Item
				label='Surname'
				name='surname'
				rules={[{ required: true, message: 'Please input rider surname' }]}>
				<Input />
			</Form.Item>
			<Form.Item
				label='Email'
				name='email'
				rules={[
					{
						required: true,
						message: 'Please input  Email',
					},
					{
						pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
						message: 'Please enter a valid email address',
					},
				]}>
				<Input disabled={fixedEmail} />
			</Form.Item>
			{CheckRiderEnabled() && (
				rider ? (
					<Form.Item label='Corporates'>
						{(() => {
							const linked = rider.corporates || [];

							if (!linked.length) return <MinusOutlined />;
							const visible = linked.slice(0, 3);
							const rest = linked.slice(3);
							return (
								<span style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
									{visible.map(c => (
										<span key={c.id} style={style.tags}>{c.name}</span>
									))}
									{rest.length > 0 && (
										<Tooltip
											title={rest.map(c => c.name).join('\n')}
											overlayStyle={{ whiteSpace: 'pre-line' }}>
											<span style={{ ...style.tags, cursor: 'default', backgroundColor: '#f0f0f0', color: '#595959' }}>
												+{rest.length}
											</span>
										</Tooltip>
									)}
								</span>
							);
						})()}
					</Form.Item>
				) : (
					<Form.Item
						label='Corporate'
						name='corporateId'
						rules={
							hasMultipleCorporates
								? [{ required: true, message: 'Please select corporate' }]
								: []
						}>
						{(() => {
							if (hasMultipleCorporates) {
								return (
									<Select
										size='medium'
										showArrow
										showSearch
										loading={corporatesLoading}
										allowClear
										placeholder='Select corporate'
										disabled={fixedCorporate}
										popupMatchSelectWidth={false}>
										{userCorporates.map((corporate) => (
											<Select.Option key={corporate.id} value={corporate.id}>
												{corporate.name}
											</Select.Option>
										))}
									</Select>
								);
							}
							if (userCorporates.length === 1) {
								return (
									<Select disabled value={userCorporates[0].id}>
										<Select.Option value={userCorporates[0].id}>
											{userCorporates[0].name}
										</Select.Option>
									</Select>
								);
							}
							return <Select disabled placeholder='No corporate available' />;
						})()}
					</Form.Item>
				)
			)}
			<Form.Item
				label='Country'
				name='country'
				defaultValue={rider ? rider.country : countryFromIp}
				rules={[{ required: true, message: 'Please select rider country' }]}>
				<Select
					size='medium'
					showArrow
					showSearch
					optionFilterProp='filterBy'
					allowClear
					optionLabelProp='label'
					onChange={(country) => {
						const foundCountry = countryPhoneCode.find((c) => c.en === country);
						if (foundCountry) {
							form.setFieldsValue({
								phoneCountryCode: foundCountry.phoneCode,
							});
							setPhoneCodeFromIp(foundCountry.phoneCode);
							setCountryFromIp(foundCountry.en);
						}
					}}
					popupMatchSelectWidth={false}>
					{countryPhoneCode.map((p) => (
						<Select.Option
							key={p.en}
							filterBy={`${p.en}`}
							label={
								<>
									<span role='img'>{p.emoji}</span>
									{p.en}
								</>
							}>
							<span role='img'>{p.emoji}</span>
							{p.en} <span style={{ color: 'gray' }} />
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label='Phone Country Code'
				name='phoneCountryCode'
				defaultValue={rider ? rider.phoneCountryCode : phoneCodeFromIp}
				rules={[{ required: true, message: 'Please select phone country code' }]}>
				<Select
					size='medium'
					showArrow
					showSearch
					optionFilterProp='filterBy'
					allowClear
					optionLabelProp='label'
					popupMatchSelectWidth={false}>
					{countryPhoneCode.map((p) => (
						<Select.Option
							key={p.en}
							filterBy={`${p.en} +${p.phoneCode}`}
							value={p.phoneCode}
							label={
								<>
									<span role='img'>{p.emoji}</span>
									{` +(${p.phoneCode})`}
								</>
							}>
							<span role='img'>{p.emoji}</span>{' '}
							<span style={{ color: 'gray' }}>{`+(${p.phoneCode})`}</span>
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label='Phone'
				name='phone'
				rules={[{ required: true, message: 'Please input rider Phone' }]}>
				<Input />
			</Form.Item>

			<Form.Item
				label='Gender'
				name='gender'
				rules={[{ required: true, message: 'Please input rider Phone' }]}>
				<Radio.Group
					options={optionsGender}
					onChange={onChangeGender}
					value={selectedGender}
					optionType='button'
					buttonStyle='solid'
				/>
			</Form.Item>
			{/* 	<Form.Item
				label='Currency'
				name='currency'
				rules={[{ required: true, message: 'Please Select currency!' }]}>
				<Select
					size='medium'
					showArrow
					showSearch
					optionFilterProp='filterBy'
					allowClear
					optionLabelProp='label'
					popupMatchSelectWidth={false}>
					{currency.map((currency) => (
						<Select.Option key={currency} label={currency}>
							{currency}
						</Select.Option>
					))}
				</Select>
			</Form.Item> */}
			<Divider />
			<Form.Item
				style={
					compactActions ? { textAlign: 'right', marginBottom: 0 } : { float: 'right' }
				}>
				<Button
					type='default'
					style={
						compactActions ? { marginRight: 8 } : { marginBottom: 32, marginRight: 8 }
					}
					onClick={() => onCancel(unsavedChanges)}>
					Cancel
				</Button>
				<Button
					type='primary'
					style={compactActions ? undefined : { marginBottom: 32 }}
					htmlType='submit'
					loading={submitLoading}
					disabled={disableSubmitUntilDirty && !unsavedChanges}>
					{submitButtonText || (!rider ? 'Save' : 'Update')}
				</Button>
			</Form.Item>
		</Form>
	);
};

export default RiderForm;
